import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  standalone: false,
  templateUrl: './alarm-state.cell.component.html',
  styleUrls: ['./alarm-state.cell.component.scss']
})
export class AlarmStateCellComponent implements ICellRendererAngularComp {

  alarmState: any;

  constructor() {}

  agInit(params: any): void {
    this.alarmState = params.value?.toUpperCase();
  }

  refresh(): boolean {
    return false;
  }
}